<template lang="html">
    <v-container fluid class="py-0">
        <v-row>
            <v-col class="col-3 py-0">
                <v-select flat solo
                          v-model="form.operator"
                          :items="operators"
                          :prepend-icon="icon"
                          :disabled="operators.length <= 1"
                          color="blue"
                >
                </v-select>
            </v-col>
            <v-col class="pt-0">
                <v-combobox
                        :search-input.sync="form.value"
                        :items="items"
                        :item-value="itemValue" :return-object="false"
                        :item-text="printItem"
                        flat solo color="blue"
                        single-line clearable
                        :hint="hint" persistent-hint
                        :placeholder="label"
                >
                    <template v-slot:item="data">
                        {{printItem(data.item)}}
                    </template>
                    <template v-slot:append-outer>
                        <v-btn small text @click="add()" color="blue">
                            <v-icon color="grey darken-2" class="mr-1">mdi-plus</v-icon>
                            Add
                        </v-btn>
                    </template>
                </v-combobox>

            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {SEARCH_NS} from "@/store/modules/search/constants";
    import {mapActions} from "vuex";

    export default {
        data: () => ({
            form: {}
        }),
        props: {
            label: String,
            icon: String,
            items: Array,
            printItem: {
                type: [Function, String, Array],
                default: (val) => val
            },
            itemValue: {
                type: [Function, String, Array],
                default: (val) => val
            },
            hint: String,
            operators: {
                type: Array,
                default: () => ['=', '!=', '>', '>=', '<', '<=']
            }
        },
        created() {
            this.resetForm();
        },
        methods: {
            ...mapActions(SEARCH_NS, [
                'addFilter'
            ]),
            add() {
                this.addFilter({
                    ...this.form,
                    label: this.label,
                    operators: [...this.operators],
                    isExclude: false,
                    isEnabled: true
                }).then(() => this.resetForm())
            },
            resetForm() {
                this.form = {
                    operator: '=',
                    value: ''
                }
            }
        }
    }
</script>